import QueryString from "qs"
import http from "../index"
import {
  apiCountry,
  apiDeletePersonal,
  apiGetListBonus,
  apiPersonnelCreate,
  apiPersonnelDetail,
  apiPersonnelUpdate,
  apiProvince,
  apiWorkHistoryCreate,
  apiWorkHistoryList,
  apiWorkingProcessList,
  apiAllowanceHistory,
  apiListSalaryHistory,
  apiWorkingProcessCreate,
  apiWorkingProcessDelete,
  apiWorkingProcessUpdate,
  apiSalaryHistoryCreate,
  apiSalaryHistoryUpdate,
  apiSalaryHistoryDelete,
  apiGetListContract,
  apiContractCreate,
  apiContractUpdate,
  apiListInsurance,
  apiGetDepartmentList,
  apiPersonnelListByDeptId,
  apiGetContractTypeList,
  apiGetSignatoryList,
  apiGetContractDetail,
  apiTimekeepingList,
  apiTimekeepingImportFile,
  apiInsuranceDetail,
  apiInsuranceCreate,
  apiInsurancePayment,
  apiApprove,
  apilistWorkDay,
  apiListContact,
  apiImport,
  apiContactCallToken,
  apiListOrder,
  apiListOrderDelete,
  apiGetCustomerListAll,
  apiOrderCreate,
  apiGetContactDetail,
  apiUpdateContactStatus,
  apiGetCustomerList,
  apiGetAgentListAll,
  apiAddAgentPersonnel,
  apiGetPositionList,
  apiGetCustomerDetail,
  apiUpdateCustomer,
  apiRemoveAgentPersonnel,
  apiGetOrderDetail,
  apiCustomerImport,
  apiOrderUpdate,
  apiUnlockUser,
  apiLockUser, apiDeleteContact, apiCreateOrderSpecial, apiResetPassword,
  apiListGift,
  apiCreateVni,
  apiCreateMic,
  apiReCreateOrder,
  apiOrdersMerge,
  apiListOrderOnline,
  apiBrowseOrderOnline,
  apiRefuseOrderOnline,
  apiCallGcn,
  apiContactCallTokenGmobile,
  apiContactCallAgentInfo,
  apiGetOrderReport,
  apiReportCall,
  apiDetailOrderReport,
  apiYearlyOrderStatistics,
  apiDetailCallReport,
  apiExportReportCall,
  apiDeleteContactList,
  apiListOrderOnlineMoto
} from "./urls"
const getListOrderOnline = params => http.get(apiListOrderOnline, { params })
const browseOrderOnline = (id, body) => http.put(apiBrowseOrderOnline(id), body)
const refuseOrderOnline = (id, body) => http.put(apiRefuseOrderOnline(id), body)
const getListGift = params => http.get(apiListGift, { params })
const personnelDetail = id => http.get(apiPersonnelDetail(id))
const deletePersonal = params => http.delete(apiDeletePersonal, { params })
const getListBonus = params => http.get(apiGetListBonus, { params })
const workHistoryList = body =>
  http.get(apiWorkHistoryList + `?${QueryString.stringify(body)}`)
const workHistoryCreate = body => http.post(apiWorkHistoryCreate({ body }))
const personnelUpdate = (id, body) => http.put(apiPersonnelUpdate(id), body)
const personnelCreate = body => http.post(apiPersonnelCreate, body)

const getProvince = body =>
  http.get(apiProvince + `?${QueryString.stringify(body)}`)
const getCountry = () => http.get(apiCountry)
const getWorkingProcessList = body =>
  http.get(apiWorkingProcessList + `?${QueryString.stringify(body)}`)
const workingProcessCreate = body => http.post(apiWorkingProcessCreate, body)
const workingProcessDelete = params =>
  http.delete(apiWorkingProcessDelete, { params })
const workingProcessUpdate = (id, body) =>
  http.put(apiWorkingProcessUpdate(id), body)
const getListSalaryHistory = body =>
  http.get(apiListSalaryHistory + `?${QueryString.stringify(body)}`)
const getAllowanceHistory = body =>
  http.get(apiAllowanceHistory + `?${QueryString.stringify(body)}`)
const salaryHistoryCreate = body => http.post(apiSalaryHistoryCreate, body)
const salaryHistoryUpdate = (id, body) =>
  http.put(apiSalaryHistoryUpdate(id), body)
const salaryHistoryDelete = params =>
  http.delete(apiSalaryHistoryDelete, { params })
const getContractList = params => http.get(apiGetListContract, { params })
const contractCreate = body => http.post(apiContractCreate, body)
const contractUpdate = (id, body) => http.put(apiContractUpdate(id), body)
const getInsuranceList = params => http.get(apiListInsurance, { params })
const getInsuranceDetail = id => http.get(apiInsuranceDetail(id))
const insuranceCreate = body => http.post(apiInsuranceCreate, body)
const getInsurancePayment = id => http.get(apiInsurancePayment(id))
const getDepartmentList = () => http.get(apiGetDepartmentList)
const getPositionList = () => http.get(apiGetPositionList)
const getPersonnelListByDeptId = params =>
  http.get(apiPersonnelListByDeptId, { params })
const getContractTypeList = () => http.get(apiGetContractTypeList)
const getSignatoryList = () => http.get(apiGetSignatoryList)
const getContractDetail = id => http.get(apiGetContractDetail(id))
const getTimekeepingList = params => http.get(apiTimekeepingList, { params })
const apiListWorkDay = params => http.get(apilistWorkDay, { params })
const getApiApprove = body => http.post(apiApprove, body)
const getTimekeepingImportFile = params =>
  http.post(apiTimekeepingImportFile, params)
const getContactList = params => http.get(apiListContact, { params })
const deleteContactList = params => http.delete(apiDeleteContact, { params })
const getContactDetail = id => http.get(apiGetContactDetail(id))
const updateContactStatus = (id, body) => http.put(apiUpdateContactStatus(id), body)
const getCustomerListAll = () => http.get(apiGetCustomerListAll)
const getCustomerList = params => http.get(apiGetCustomerList, { params })
const getCustomerDetail = id => http.get(apiGetCustomerDetail(id))
const updateCustomer = (id, body) => http.put(apiUpdateCustomer(id), body)
const getImport = params => http.post(apiImport, params)
const customerImport = params => http.post(apiCustomerImport, params)
const getContactCallToken = params => http.post(apiContactCallToken, params)
const getOrderList = params => http.get(apiListOrder, { params })
const deleteOrder = params => http.delete(apiListOrderDelete, { params })
const orderCreate = body => http.post(apiOrderCreate, body)
const orderCreateSpecial = body => http.post(apiCreateOrderSpecial, body)
const getOrderDetail = id => http.get(apiGetOrderDetail(id))
const orderUpdate = (id, body) => http.put(apiOrderUpdate(id), body)
const getAgentListAll = () => http.get(apiGetAgentListAll)
const addAgentPersonnel = body => http.put(apiAddAgentPersonnel, body)
const removeAgentPersonnel = body => http.put(apiRemoveAgentPersonnel, body)
const unlockUser = (id, body) => http.post(apiUnlockUser(id), body)
const lockUser = (id, body) => http.post(apiLockUser(id), body)
const resetPassword = (id, body) => http.put(apiResetPassword(id), body)

const createVni = params => http.post(apiCreateVni, params)
const createMic = params => http.post(apiCreateMic, params)
const callGcn = params => http.get(apiCallGcn, { params })
const reCreateOrder = params => http.post(apiReCreateOrder, params)
const getOrdersMerge = (id, body) => http.post(apiOrdersMerge(id), body)
const getContactCallTokenGmobile = params => http.post(apiContactCallTokenGmobile, params)
const getContactCallAgentInfo = params => http.post(apiContactCallAgentInfo, params)
const getOrderReport = params => http.get(apiGetOrderReport, { params })
const getDetailOrderReport = (id, params) => http.get(apiDetailOrderReport(id), { params })
const getReportCall = params => http.get(apiReportCall, { params })
const exportReportCall = params =>
  http.get(apiExportReportCall, { params, responseType: "blob" })
const getDetailDepartmentCallReport = (id, params) => http.get(apiDetailCallReport(id), { params })
const getYearlyOrderStatistics = params => http.get(apiYearlyOrderStatistics, { params })
const getDeleteContactList = params => http.get(apiDeleteContactList, { params })
const getListOrderOnlineMoto = params => http.get(apiListOrderOnlineMoto, { params })
const HRService = {
  customerImport,
  getImport,
  apiListWorkDay,
  getApiApprove,
  getTimekeepingImportFile,
  getTimekeepingList,
  personnelDetail,
  deletePersonal,
  getListBonus,
  workHistoryList,
  workHistoryCreate,
  personnelUpdate,
  personnelCreate,
  getProvince,
  getCountry,
  getWorkingProcessList,
  getAllowanceHistory,
  getListSalaryHistory,
  salaryHistoryCreate,
  salaryHistoryUpdate,
  salaryHistoryDelete,
  workingProcessCreate,
  workingProcessDelete,
  workingProcessUpdate,
  getContractList,
  contractCreate,
  contractUpdate,
  getInsuranceList,
  getInsuranceDetail,
  insuranceCreate,
  getDepartmentList,
  getPositionList,
  getPersonnelListByDeptId,
  getContractTypeList,
  getSignatoryList,
  getContractDetail,
  getInsurancePayment,
  getContactList,
  deleteContactList,
  getOrderList,
  getContactCallToken,
  getCustomerListAll,
  getCustomerList,
  orderCreate,
  orderCreateSpecial,
  getContactDetail,
  updateContactStatus,
  getAgentListAll,
  addAgentPersonnel,
  getCustomerDetail,
  updateCustomer,
  removeAgentPersonnel,
  getOrderDetail,
  orderUpdate,
  unlockUser,
  lockUser,
  deleteOrder,
  resetPassword,
  getListGift,
  createVni,
  createMic,
  callGcn,
  reCreateOrder,
  getOrdersMerge,
  getListOrderOnline,
  browseOrderOnline,
  refuseOrderOnline,
  getContactCallTokenGmobile,
  getContactCallAgentInfo,
  getOrderReport,
  getDetailOrderReport,
  getReportCall,
  getYearlyOrderStatistics,
  getDetailDepartmentCallReport,
  exportReportCall,
  getDeleteContactList,
  getListOrderOnlineMoto
}

export default HRService

